import { Injectable } from '@angular/core';
import type { TBookAlias } from '@shared/jp/product';
import {
  INPUT_NAME_KUN_CHAN,
  BOOK_ALIAS_LETS_MAKE_METRO,
  BOOK_ALIAS_TOKYO_METRO,
  INPUT_NAME_TRAIN_LINE,
} from '@shared/jp/product';
import type { ICommonBookData } from '@shared/jp/models';
import { LoaderService } from '@studiobuki/web-core/lib/loader';
import {
  INPUT_NAME_GLASSES,
  INPUT_NAME_HAIR_COLOR,
  INPUT_NAME_HAIR_STYLE,
  INPUT_NAME_KIDS_NAME,
  INPUT_NAME_CHARACTER,
  INPUT_NAME_GENDER,
  INPUT_VALUE_SKIN_COLOR_NUTMEG,
} from '@shared/common/product';
import { BookTokyoMetroService } from 'src/app/pages/book-page/pages/book-tokyo-metro-page/book-tokyo-metro.service';
import { BookLetsMakeMetroService } from 'src/app/pages/book-page/pages/book-lets-make-metro-page/book-lets-make-metro.service';

@Injectable({
  providedIn: 'root',
})
export class BooksService {
  constructor(
    private _bookTokyoMetroService: BookTokyoMetroService,
    private _bookLetsMakeMetroService: BookLetsMakeMetroService,
    private _loader: LoaderService,
  ) {}

  async createBookByAlias(
    alias: TBookAlias,
    /** IBookInputNameToValueMap */
    bookCreateData: any,
    common?: Partial<ICommonBookData>,
  ) {
    this._loader.show();

    try {
      switch (alias) {
        case BOOK_ALIAS_TOKYO_METRO:
          return await this._bookTokyoMetroService.createBook(
            {
              heroName: bookCreateData[INPUT_NAME_KIDS_NAME],
              kunChan: bookCreateData[INPUT_NAME_KUN_CHAN],
              trainLine: bookCreateData[INPUT_NAME_TRAIN_LINE],
              gender: bookCreateData[INPUT_NAME_GENDER],
              character: bookCreateData[INPUT_NAME_CHARACTER],
              glasses: bookCreateData[INPUT_NAME_GLASSES],
            },
            common,
          );
        case BOOK_ALIAS_LETS_MAKE_METRO:
          return await this._bookLetsMakeMetroService.createBook(
            {
              heroName: bookCreateData[INPUT_NAME_KIDS_NAME],
              kunChan: bookCreateData[INPUT_NAME_KUN_CHAN],
              gender: bookCreateData[INPUT_NAME_GENDER],
              skinColor: INPUT_VALUE_SKIN_COLOR_NUTMEG,
              hairColor: bookCreateData[INPUT_NAME_HAIR_COLOR],
              hairStyle: bookCreateData[INPUT_NAME_HAIR_STYLE],
              glasses: bookCreateData[INPUT_NAME_GLASSES],
            },
            common,
          );
        default:
          throw new Error(`Unexpected alias "${alias}"`);
      }
    } catch (e: any) {
      alert(`Something went wrong. ${'message' in e ? e.message : e}`);
      throw e;
    } finally {
      this._loader.hide();
    }
  }
}
